import React from "react";
import {
  Box,
  Grid,
  Divider,
  Typography,
  Card,
  CardContent,
  CardActions,
  CardMedia,
  Container,
  Hidden,
} from "@material-ui/core";

import SuccessfulFace from "../../../containers/QCV/SuccessfulFace/successfulFace";
import CeremonyGallery from "../CeremonyGallery/CeremonyGallery";
import QuyChe from "../QuyChe";

import { ROUTER } from "../../../constants";
import { QCV2026_LINKS } from "../../../constants/qcv2026.config";
import { useStyles } from "./styled";
import { useScreenSize } from "../../../hooks/useScreenSize";

import tut from "../../../assets/image/home/tutorial-icon.png";
// import video30 from "../../../assets/image/home/Comp 1.mp4";
// import cytast30 from "../../../assets/image/home/cytast30.jpg";
// import frame30 from "../../../assets/image/home/frame-30.png";
import logoDoan from "../../../assets/image/home/logoDoan.png";
import backdrop from "../../../assets/image/home/backdrop.jpg";
import paperIcon from "../../../assets/image/tnv/qcv-icon.png";

import logoBoKHCN from "../../../assets/image/home/logoBoKHCN.png";
import bannerTitle from "../../../assets/image/home/qcv-banner-title.png";
import registerIcon from "../../../assets/image/home/register-icon.png";

const topicList = [
  {
    key: "thanh-tích",
    title: "Quy chế xét thưởng",
    containerColor: "#F5F1EE",
    imgSource: paperIcon,
    // Bấm "Chi tiết" mở thẳng file PDF Quyết định & Quy chế (Google Drive).
    // Nếu chưa cấu hình link PDF thì fallback về trang Quy chế nội bộ.
    to: QCV2026_LINKS.quyetDinhQuyChe || ROUTER.QCV.QUY_CHE,
    external: !!QCV2026_LINKS.quyetDinhQuyChe,
    description:
      "Quy chế Giải thưởng ban hành theo Quyết định số 1299-QĐ/TWĐTN-KHCN ngày 25/5/2026 của Ban Bí thư Trung ương Đoàn.",
  },
  {
    key: "dang-ky",
    title: "Đăng ký",
    containerColor: "#EFEEF5",
    imgSource: registerIcon,
    to: ROUTER.DANG_KY_HO_SO,
    description:
      "Đăng ký tham gia hệ thống bằng việc hoàn thiện hồ sơ đăng ký, khai các thành tích cá nhân và chờ hệ thống xét duyệt.",
  },
  {
    key: "binh-chọn",
    title: "Hướng dẫn đăng ký",
    containerColor: "#F4F5EE",
    imgSource: tut,
    to: ROUTER.QCV.HUONG_DAN_SU_DUNG,
    description: "Vui lòng ấn vào Chi tiết bên dưới để xem hướng dẫn sử dụng",
  },
];

const LOGO_30_WIDTH = 200;
// const LOGO_30_HEIGHT = (519 / 549) * 200;
const LOGO_30_SCALE = LOGO_30_WIDTH / 549;

function GioiThieuQCV() {
  const classes = useStyles(LOGO_30_WIDTH);
  const isMobileMode = useScreenSize();

  return (
    <>
      <Box
        style={{
          backgroundImage: `url(${backdrop})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <Container maxWidth="lg">
          <Box
            paddingY={6}
            display="flex"
            alignItems="center"
            flexDirection={isMobileMode ? "column" : "row"}
          >
            <Box display="flex">
              <img
                src={logoDoan}
                alt="logo-doan"
                style={{ minWidth: 64, width: "calc(100vw / 20)" }}
              />
              <img
                src={logoBoKHCN}
                alt="logo-bo-khcn"
                style={{
                  minWidth: 64,
                  width: "calc(100vw / 20)",
                  marginTop: 10,
                }}
              />
            </Box>
            <Box
              display="flex"
              alignItems="center"
              justifyContent="flex-end"
              style={{ flexGrow: 1 }}
            >
              <img
                src={bannerTitle}
                alt="title"
                style={{
                  marginLeft: isMobileMode ? 0 : 8,
                  width: isMobileMode ? "100%" : "calc(100% - 100vw / 30)",
                }}
              />
            </Box>
          </Box>
        </Container>
      </Box>
      <Container maxWidth="md">
        <Box className="formal-text">
          <p>
            Thực hiện chủ trương của Đảng, Nhà nước về phát triển nguồn nhân lực
            trẻ tài năng Quốc gia, được sự đồng ý của Thủ tướng Chính phủ, từ
            năm 2003 Trung ương Đoàn TNCS Hồ Chí Minh chủ trì phối hợp với Bộ
            Khoa học và Công nghệ tổ chức Giải thưởng Khoa học công nghệ Quả Cầu
            Vàng nhằm phát hiện, tôn vinh tài năng trẻ Việt Nam (không quá 35
            tuổi tính đến năm xét trao giải) đang học tập, nghiên cứu và làm
            việc ở trong hoặc ngoài nước có thành tích xuất sắc trong lĩnh vực
            khoa học công nghệ nhằm thúc đẩy phong trào học tập, nghiên cứu, ứng
            dụng khoa học công nghệ, xây dựng và phát triển đội ngũ nhân tài
            trong lĩnh vực khoa học công nghệ, góp phần phát triển đất nước Việt
            Nam phồn vinh, hạnh phúc. Giải thưởng được trao hằng năm, mỗi năm có
            tối đa 10 cá nhân được nhận Giải thưởng.
          </p>
          <ul>
            <li>
              Từ năm 2003-2010: Giải thưởng được Trung ương Đoàn sáng lập vào
              năm 2003 với tên gọi “Giải thưởng Công nghệ thông tin Thanh niên
              mang tên Quả Cầu Vàng” vinh danh 10 tài năng trẻ có thành tích
              xuất sắc nhất toàn quốc trong lĩnh vực CNTT nhằm phát triển nguồn
              nhân lực CNTT và phát huy vai trò xung kích, tiên phong của thanh
              niên Việt Nam trong đẩy mạnh ứng dụng CNTT vào các lĩnh vực của
              đời sống xã hội.
            </li>
            <br />
            <li>
              Từ năm 2011-2015: đổi tên là{" "}
              <i>
                Giải thưởng Khoa học Kỹ thuật Thanh niên mang tên Quả Cầu Vàng
              </i>{" "}
              và mở rộng thành 4 lĩnh vực xét giải thưởng: Công nghệ thông tin
              và truyền thông, Công nghệ Y- dược, Công nghệ Sinh học và Công
              nghệ Môi trường.
            </li>
            <br />
            <li>
              Từ năm 2016-2020, đổi tên là{" "}
              <i>Giải thưởng Khoa học công nghệ Thanh niên Quả Cầu Vàng </i>và
              mở rộng thành 5 lĩnh vực xét giải thưởng: Công nghệ thông tin và
              truyền thông, Công nghệ Y- dược, Công nghệ Sinh học, Công nghệ Môi
              trường và Công nghệ Vật liệu mới.
            </li>
            <br />
            <li>
              Từ năm 2021, đổi tên gọi thành{" "}
              <i>Giải thưởng Khoa học công nghệ Quả Cầu Vàng </i>và sửa đổi, bổ
              sung, mở rộng các ngành trong 5 lĩnh vực xét giải thưởng: Công
              nghệ thông tin, chuyển đổi số và tự động hóa; Công nghệ Y- dược;
              Công nghệ Sinh học; Công nghệ Môi trường và Công nghệ Vật liệu
              mới.
            </li>
            <br />
            <li>
              Từ năm 2026: Giải thưởng sửa đổi nhằm kịp thời cụ thể hóa triển
              khai Nghị quyết số 57-NQ/TW ngày 22/12/2024 của Bộ Chính trị về đột
              phá phát triển khoa học, công nghệ, đổi mới sáng tạo và chuyển đổi
              số quốc gia; Quyết định số 21/2026/QĐ-TTg ngày 30/4/2026 của Thủ
              tướng Chính phủ ban hành Danh mục công nghệ chiến lược và Danh mục
              sản phẩm công nghệ chiến lược. Giải thưởng mở rộng thành 10 lĩnh
              vực xét giải và ưu tiên các lĩnh vực công nghệ chiến lược quốc gia,
              các lĩnh vực khoa học công nghệ có ý nghĩa quan trọng đối với phát
              triển đất nước, gồm: [1] Công nghệ số; [2] Công nghệ mạng di động
              thế hệ sau, an ninh mạng và lượng tử; [3] Công nghệ robot và tự
              động hóa; [4] Công nghệ y sinh, dược và sinh học ứng dụng; [5] Công
              nghệ năng lượng và vật liệu tiên tiến; [6] Công nghệ chip bán dẫn;
              [7] Công nghệ môi trường và phát triển bền vững; [8] Công nghệ
              biển, đại dương và lòng đất; [9] Công nghệ hàng không và vũ trụ;
              [10] Công nghệ đường sắt tốc độ cao và đường sắt đô thị.
            </li>
          </ul>
          <p>
            Đến năm 2025, đã có 224 cá nhân xuất sắc trong và ngoài nước được
            nhận Giải thưởng, trong đó: lĩnh vực Công nghệ thông tin, chuyển đổi
            số và tự động hóa có 115 cá nhân; lĩnh vực Công nghệ Y dược có 34 cá
            nhân; lĩnh vực Công nghệ Sinh học có 21 cá nhân; lĩnh vực Công nghệ
            Môi trường có 34 cá nhân và lĩnh vực Công nghệ Vật liệu mới có 20 cá
            nhân.
          </p>
          <p>
            <i>
              Trường Công nghệ, Đại học Kinh tế Quốc dân là đơn vị đồng hành của
              Giải thưởng.
            </i>
          </p>
        </Box>
        <Grid container spacing={4}>
          {topicList.map((e) => (
            <Grid key={e.key} item xs={12} md={4} style={{ marginBottom: 32 }}>
              <Card
                style={{
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <Box
                  display="flex"
                  paddingY={4}
                  justifyContent="center"
                  alignItems="center"
                  bgcolor={e.containerColor}
                >
                  <CardMedia
                    src={e.imgSource}
                    component="img"
                    style={{ width: "45%" }}
                  />
                </Box>
                <CardContent style={{ flexGrow: 1, textAlign: "justify" }}>
                  <Typography
                    variant="h5"
                    style={{
                      marginTop: 24,
                      marginBottom: 8,
                      textAlign: "center",
                      fontFamily: "WorkSans-ExtraBold",
                    }}
                  >
                    <b>{e.title}</b>
                  </Typography>
                  <Box style={{ color: "#55626a", lineHeight: "1.68421053em" }}>
                    {e.description}
                  </Box>
                </CardContent>
                <CardActions>
                  <a
                    href={e.to}
                    style={{ margin: "auto", color: "#ee6064" }}
                    {...(e.external
                      ? { target: "_blank", rel: "noreferrer" }
                      : {})}
                  >
                    <b>Chi tiết</b>
                  </a>
                </CardActions>
              </Card>
            </Grid>
          ))}
        </Grid>
        <Divider
          style={{
            width: 64,
            height: 4,
            margin: "64px auto 16px",
            backgroundColor: "#ee6064",
          }}
        />
        <Typography
          variant="h4"
          style={{
            textAlign: "center",
            fontFamily: "WorkSans-ExtraBold",
            marginBottom: 8,
          }}
        >
          <b>Một số gương mặt Quả Cầu Vàng tiêu biểu</b>
        </Typography>
        <SuccessfulFace />
        <Divider
          style={{
            width: 64,
            height: 4,
            margin: "64px auto 16px",
            backgroundColor: "#ee6064",
          }}
        />
        <Typography
          variant="h4"
          style={{
            textAlign: "center",
            fontFamily: "WorkSans-ExtraBold",
            marginBottom: 24,
          }}
        >
          <b>Một số hình ảnh lễ trao Giải thưởng</b>
        </Typography>
        <CeremonyGallery />
        <Divider
          id="quy-che"
          style={{
            width: 64,
            height: 4,
            margin: "64px auto 16px",
            backgroundColor: "#ee6064",
          }}
        />
        <Typography
          variant="h4"
          style={{ textAlign: "center", fontFamily: "WorkSans-ExtraBold" }}
        >
          <strong>QUY CHẾ XÉT THƯỞNG</strong>
        </Typography>
        <Typography
          variant="h6"
          style={{ textAlign: "center", color: "#55626a", marginBottom: 16 }}
        >
          <i>
            (Theo Quy chế Giải thưởng ban hành kèm theo Quyết định số
            1299-QĐ/TWĐTN-KHCN ngày 25/5/2026 của Ban Bí thư Trung ương Đoàn TNCS
            Hồ Chí Minh)
          </i>
        </Typography>
        <QuyChe />
      </Container>
      <Hidden smDown>
        <Box
          className={classes.logo30}
          position="sticky"
          height={0}
          bottom={128}
        >
          <Box
            position="relative"
            width={549 * LOGO_30_SCALE}
            height={519 * LOGO_30_SCALE}
          >
            {/* <video loop muted autoPlay src={video30} style={{
              width: `calc(100% - ${96 * LOGO_30_SCALE}px)`,
              height: `calc(100% - ${56 * LOGO_30_SCALE}px)`,
              top: -LOGO_30_HEIGHT,
              bottom: 0,
              left: 48 * LOGO_30_SCALE,
              right: 48 * LOGO_30_SCALE,
              position: 'absolute',
            }} /> */}
            {/* <img
              src={cytast30}
              draggable={false}
              style={{
                width: `calc(100% - ${96 * LOGO_30_SCALE + 2}px)`,
                height: `calc(100% - ${56 * LOGO_30_SCALE + 4}px)`,
                top: -LOGO_30_HEIGHT,
                bottom: 0,
                left: 48 * LOGO_30_SCALE,
                right: 48 * LOGO_30_SCALE,
                position: "absolute",
              }}
            /> */}
            {/* <img
              className={classes.frame30}
              src={frame30}
              draggable={false}
              style={{ top: -LOGO_30_HEIGHT }}
            /> */}
          </Box>
        </Box>
      </Hidden>
    </>
  );
}

export default GioiThieuQCV;
